module.exports = __webpack_public_path__ + "becc018.woff";